import * as React from "react";
import { Icon } from '@fluentui/react';
import { Button, Flex, FlexItem, Grid, MenuButton, Text, Tooltip } from "@fluentui/react-northstar";
import { ExclamationTriangleIcon, MoreIcon, BulletsIcon } from '@fluentui/react-icons-northstar';
import { withTranslation, WithTranslation } from "react-i18next";
import { DateTimeParser } from "../../../helpers/date-time";
import { LoaderInfinite } from "../../loaders/loaders";
import StatusQueueConstants from "../../../constants/status-queue";
import Roles from "../../../constants/roles";

interface IListagemExpiradoProps extends WithTranslation {
    item: any;
    status: string,
    getLabelStatusLocale: Function,
    onViewHistory: Function,
    role: string,
    isAdmin: boolean,
    pageSize: number,
    loadingInfinite: boolean,
    isTeamContext?: boolean,
}

const ListagemExpirado: React.FunctionComponent<IListagemExpiradoProps> = props => {
    const localize = props.t;

    return (
        <Flex fill column>
            {!props.item.length ?
                <Flex hAlign="center" gap="gap.medium" styles={{ marginTop: '60px' }}>
                    <ExclamationTriangleIcon outline />
                    <Text size="small" weight="light" content={`${localize("NaoExistem")} atendimentos expirados ${localize("NestaUnidade")}`} />
                </Flex>
                :
                <Grid columns="minmax(320px, 370px) minmax(70px, 70px) 0.5fr 0.5fr">
                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text content={localize("StatusAtendimento")} className="margin-style header-nome-serventia" />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip
                                trigger={<Icon className="margin-style info-icon" iconName="Info" />}
                                content={
                                    <React.Fragment>
                                        <Text content={`\u25CF ${localize("UsuarioNaFila")}`} />
                                        <br /><br />
                                        <Text content={`\u25CF ${localize("AtendimentoConfirmado")}`} />
                                        <br /><br />
                                        <Text content={`\u25CF ${localize("UsuarioEntrou")}`} />
                                    </React.Fragment>
                                }
                            />
                        </FlexItem>
                    </Flex>

                    <Flex gap="gap.small" className="header">

                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("Horario")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("HorarioSolicitacao")} />
                        </FlexItem>
                    </Flex>
                    <Flex gap="gap.small" className="header" hAlign="center">
                        <FlexItem>
                            <Text className="margin-style" content={localize("HorarioEncerramento")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("HorarioEncerramento")} />
                        </FlexItem>
                    </Flex>

                    {props.item.map((item: any, index: number) => {
                        let queue = item?.queue;
                        let history = queue?.History ?? null;
                        let horarioEncerramento = "";

                        if (history) {
                            let itemEncerradoInatividade = history.find((e: any) => e.status == StatusQueueConstants.atendimentoInativo);

                            horarioEncerramento = DateTimeParser.dateOffsetParser(itemEncerradoInatividade?.updated).format("HH:mm");
                        }

                        let queueId = `#${queue?.id.substr(queue?.id.length - 6)} ${props.getLabelStatusLocale(queue?.status)}`;

                        if (queue.AdditionalData?.nrProcesso) {
                            queueId = `${queue.AdditionalData?.nrProcesso} ${props.getLabelStatusLocale(queue?.status)}`;
                        }

                        return (
                            <React.Fragment key={index}>
                                <Flex gap="gap.medium" vAlign="center" className={queue.isSelected ? "row row-active" : "row"}>
                                    {!props.isTeamContext ?
                                        <FlexItem>
                                            <Text styles={{ marginLeft: '3.5rem' }} content={queueId} />
                                        </FlexItem>
                                        :
                                        <FlexItem>
                                            <Tooltip
                                                trigger={
                                                    <Text styles={{ marginLeft: '3.5rem' }} content={`#${queue.id.substr(queue.id.length - 6)} ${props.getLabelStatusLocale(queue.status)}`} />
                                                }
                                                content={`Unidade: ${queue?.nome}`}
                                                position="after"
                                                align="center"
                                            />
                                        </FlexItem>
                                    }
                                </Flex>

                                {!props.isAdmin && props.role == Roles.leitor ?
                                    <Flex className={queue.isSelected ? "row row-active" : "row"} />
                                    :
                                    <Flex gap="gap.medium" vAlign="center" className={queue.isSelected ? "row row-active" : "row"}>
                                        <FlexItem>
                                            <MenuButton
                                                tabIndex={-1}
                                                trigger={<Button icon={<MoreIcon />} iconOnly text />}
                                                on="click"
                                                menu={[
                                                    {
                                                        key: 'details',
                                                        content: localize("Detalhes"),
                                                        icon: <BulletsIcon outline />,
                                                        onClick: () => props.onViewHistory(queue.id),
                                                    },
                                                ]}
                                            />
                                        </FlexItem>
                                    </Flex>
                                }

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text
                                            content={
                                                queue?.Schedule ?
                                                    DateTimeParser.dateOffsetParser(queue?.Schedule.date).format("HH:mm") :
                                                    DateTimeParser.dateOffsetParser(queue?.created).format("HH:mm")
                                            }
                                        />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.medium" vAlign="center" hAlign="center" className={queue.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        <Text content={horarioEncerramento} />
                                    </FlexItem>
                                </Flex>
                            </React.Fragment>
                        );
                    })}
                </Grid>
            }

            {(props.loadingInfinite && props.item.length >= props.pageSize) && <LoaderInfinite />}
        </Flex>
    );
};

const listagemExpiradoWithTranslation = withTranslation()(ListagemExpirado);
export default listagemExpiradoWithTranslation;